import store from '@/store/store'
import { setShowModalType } from '@/store/slices/modal/action'
import { ShowModalType } from '@/scenes/engine/common/constants'
import { openPremiumPrompt } from '@/services/ai/openPremiumPrompt'
import { LIMITED_OFFER_PREMIUM_SOURCE } from '@/scenes/Editor/components/Navbar/components/SignIn/Metsikon/metsikonPlanConfig'
import { clearPendingLimitedOffer, limitedOfferPurchaseCallback } from './limitedOfferTrigger'
import { waitForLimitedOfferPrices } from './limitedOfferPrices'

/**
 * Opens the limited-offer promo for review, after its prices load (or the wait
 * times out); it is not counted against the caps.
 */
export function openLimitedOffer(): void {
  void waitForLimitedOfferPrices().then(() => {
    clearPendingLimitedOffer()
    store.dispatch(setShowModalType(ShowModalType.LIMITED_OFFER))
  })
}

/**
 * The offer's CTA: opens the paywall's payment form for the yearly Premium plan
 * without trial, with the offer's Paddle discount when configured. A completed
 * purchase stops the campaign.
 */
export function openLimitedOfferPaywall(): void {
  openPremiumPrompt({ source: LIMITED_OFFER_PREMIUM_SOURCE, type: 'Standard', callback: limitedOfferPurchaseCallback() })
}

const DEBUG_HOOK_NAME = 'showLimitedOffer'

/** Exposes `window.showLimitedOffer()` in sandbox builds only. Returns the cleanup. */
export function installLimitedOfferDebugHook(): () => void {
  if (process.env.REACT_APP_IS_SANDBOX !== 'true') return () => {}
  const target = window as unknown as Record<string, unknown>
  target[DEBUG_HOOK_NAME] = openLimitedOffer
  return () => {
    if (target[DEBUG_HOOK_NAME] === openLimitedOffer) delete target[DEBUG_HOOK_NAME]
  }
}
